// extracted by mini-css-extract-plugin
export default {"container":"dropbox_container__6A1rc","wrapper":"dropbox_wrapper__UyZ7r","focused":"dropbox_focused__I+PGr"};